import { render, staticRenderFns } from "./TierBar.vue?vue&type=template&id=31ea0b84&scoped=true&"
import script from "./TierBar.vue?vue&type=script&lang=js&"
export * from "./TierBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ea0b84",
  null
  
)

export default component.exports